import { render, staticRenderFns } from "./custom-dropdown-field.vue?vue&type=template&id=4b9a76aa"
import script from "./custom-dropdown-field.vue?vue&type=script&lang=js"
export * from "./custom-dropdown-field.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports